<template>
  <div class="space-between-y">
    <div class="both-sides">
      <el-select width="150" v-model="form.tagId"
                 :placeholder="options.tags?.length === 0 ? '暂无分组可供选择': '请选择分组'" filterable clearable
                 @change="getList">
        <el-option v-for="(item,index) in options.tags" :key="index" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-download" @click="handleDownload">下载当前页面所有图片</el-button>
    </div>

    <div class="imgs">
      <div v-for="(item,index) in list" :key="index" class="img-card">
        <!-- 已失效: 占位图 -->
        <div v-if="item.expireHint === '已失效'" class="img-expired">
          <i class="el-icon-picture-outline"></i>
          <span>已失效</span>
        </div>
        <!-- 正常/归档/解冻中: 显示图片 -->
        <cloud-img v-else :url="item.url" :img-height="150" :img-width="150" :fit="'contain'"></cloud-img>

        <!-- 解冻按钮 (仅归档状态显示) -->
        <el-button v-if="item.needRestore" size="mini" type="warning" @click="handleRestore(item.url, index)"
                   :loading="item._restoring">
          {{ item._restoring ? '解冻中...' : '解冻查看' }}
        </el-button>

        <!-- 失效提示 -->
        <div v-if="item.expireHint && item.expireHint !== '已失效'" class="img-hint expire-hint">
          {{ item.expireHint }}
        </div>

        <!-- 归档状态提示 -->
        <div v-if="item.archiveHint" class="img-hint archive-hint">
          {{ item.archiveHint }}
        </div>
      </div>

      <div v-if="list?.length === 0">
        <el-empty description="暂无图片"></el-empty>
      </div>
    </div>
    <pagination v-model="page" @updated="getList"></pagination>
  </div>
</template>

<script>
import Pagination from "@/components/base/layout/Pagination.vue";
import {eventorder} from "@/api/eventorder";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import CloudImgs from "@/components/base/layout/img/CloudImgs.vue";
import InputItem from "@/components/base/layout/InputItem.vue";
import {utils} from "@/util/utils";

export default {
  name: 'EventOrderImgs',
  components: {
    InputItem,
    CloudImgs,
    CloudImg,
    Pagination
  },
  props: {
    orderId: null,
    type: Number,
  },
  data() {
    return {
      form: {
        tagId: null,
      },

      page: {
        size: 10,
        current: 1,
        total: 0,
      },

      list: [],

      options: {
        tags: [],
      },

    };
  },

  created() {
    this.getList();

    eventorder.listEventTag(this.orderId).then(res => {
      this.options.tags = res.data;
    })

  },

  methods: {
    handleDownload() {
      let urls = this.list.map(item => item.url);
      console.log(urls);
      utils.file.handleDownload(urls);
    },
    getList(current) {
      this.page.current = current === null ? 1 : this.page.current;
      eventorder.showImgs(this.orderId, this.form.tagId, this.page.current, this.page.size).then(res => {
        let page = res.data;
        this.list = page.list || [];
        this.page.total = page.total;
      });
    },
    /**
     * 触发 COS 解冻
     */
    handleRestore(fileUrl, index) {
      const item = this.list[index];
      item._restoring = true;

      this.$axios.post('/cos/restore', { fileUrl: fileUrl, days: 7 }).then(res => {
        this.$message.success('解冻请求已提交，预计 1-5 分钟后可查看');
        // 轮询检查解冻状态
        this.pollRestoreStatus(fileUrl, index);
      }).catch(err => {
        this.$message.error('解冻失败: ' + (err.response?.data?.msg || err.message));
        item._restoring = false;
      });
    },
    /**
     * 轮询解冻状态
     */
    pollRestoreStatus(fileUrl, index, retries = 30) {
      if (retries <= 0) {
        this.list[index]._restoring = false;
        this.$message.info('解冻超时，请稍后刷新页面重试');
        return;
      }

      setTimeout(() => {
        this.$axios.post('/cos/status', `fileUrl=${encodeURIComponent(fileUrl)}`, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(res => {
          const status = res.data;
          const item = this.list[index];
          item.cosStatus = status;

          if (status === 'RESTORED' || status === 'STANDARD' || status === 'IA') {
            item._restoring = false;
            item.needRestore = false;
            this.$message.success('解冻完成');
            this.getList(); // 刷新列表
          } else if (status === 'RESTORING') {
            item._restoring = true;
            this.pollRestoreStatus(fileUrl, index, retries - 1);
          } else {
            item._restoring = false;
          }
        }).catch(() => {
          this.pollRestoreStatus(fileUrl, index, retries - 1);
        });
      }, 10000); // 每 10 秒检查一次
    },
  },
};
</script>

<style scoped>
.imgs {
  display: flex;
  flex-wrap: wrap;
  justify-items: center;
  gap: 12px;
}

.img-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px;
}

.img-expired {
  width: 150px;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  color: #c0c4cc;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.img-expired i {
  font-size: 40px;
  margin-bottom: 8px;
}

.img-expired span {
  font-size: 12px;
}

.img-hint {
  font-size: 11px;
  margin-top: 4px;
  text-align: center;
  line-height: 1.3;
  max-width: 150px;
  word-break: break-all;
}

.expire-hint {
  color: #e6a23c;
}

.archive-hint {
  color: #909399;
}
</style>
